import { connect } from 'react-redux';



// Actions
import { getOfficesShortList, getPublicZoneList } from '../Offices/officesActions';
import { getOrganizationMembersList } from '../Projects/projectsActions';
import { getTaskLocation } from '../Tasks/tasksActions';
// Component
import ClockInOut from './ClockInOut';
import { getClockInOutList } from './clockInOutActions';


// const dummyClockInOutList = [
//   {
//     employee: {
//       id: '8c41f3d8-cea6-4c43-9517-fb1865c68478',
//       first_name: 'Rakibul Hasan',
//       last_name: 'Showrov',
//       email: 'rakibul@spacesoft.co',
//       color: null,
//       role: 'employee',
//       office: {
//         id: 'e0c16b9f-2db0-4043-a53d-5fb1592cfea2',
//         name: 'Apploye HQ',
//       },
//       phone: '+8801626360824',
//       avatar: null,
//       user_code: null,
//       geofence_time_clock: false,
//       should_track: true,
//       location_track: true,
//       clockin_selfie: false,
//       designation: 'Software Engineer',
//     },
//     attendances: [
//       {
//         id: 'd73d452b-158e-4bb5-86fa-3ce261bf2d2a',
//         clockin_timestamp: 1771682312,
//         clockout_timestamp: 1771682404,
//         clockin_lat: '23.833324000000000000000',
//         clockin_long: '90.350199000000000000000',
//         clockout_lat: '23.833290000000001640501',
//         clockout_long: '90.350161900000003356581',
//         clocked_out_reason: 'visited_another_camp',
//         selfie: null,
//         office: '8',
//         office_id: '10235033-738f-4b7d-97bb-58e429b74af6',
//         public_zone: 'Arafat',
//         public_zone_id: '573eddc7-f7c2-45d8-9a6b-3d8f16ddc343',
//       },
//       {
//         id: '3c1150c5-cccc-dddd-eeee-fff0000aaaaa',
//         clockin_timestamp: 1771670000,
//         clockout_timestamp: 1771675000,
//         clockin_lat: '23.833340000000000000000',
//         clockin_long: '90.350210000000000000000',
//         clockout_lat: '23.833350000000000000000',
//         clockout_long: '90.350220000000000000000',
//         clocked_out_reason: 'end_of_shift',
//         selfie: null,
//         office: '8',
//         office_id: '10235033-738f-4b7d-97bb-58e429b74af6',
//         public_zone: 'Arafat',
//         public_zone_id: '573eddc7-f7c2-45d8-9a6b-3d8f16ddc343',
//       },
//       {
//         id: '4d2261d6-dddd-eeee-ffff-000abbbccccb',
//         clockin_timestamp: 1771677000,
//         clockout_timestamp: 1771681000,
//         clockin_lat: '23.833360000000000000000',
//         clockin_long: '90.350230000000000000000',
//         clockout_lat: '23.833370000000000000000',
//         clockout_long: '90.350240000000000000000',
//         clocked_out_reason: 'lunch_break',
//         selfie: null,
//         office: '8',
//         office_id: '10235033-738f-4b7d-97bb-58e429b74af6',
//         public_zone: 'Arafat',
//         public_zone_id: '573eddc7-f7c2-45d8-9a6b-3d8f16ddc343',
//       },
//       {
//         id: '2b0049b4-bca7-4205-bad0-4f99b8abbd65',
//         clockin_timestamp: 1771667262,
//         clockout_timestamp: 1771667442,
//         clockin_lat: '23.832982000000000000000',
//         clockin_long: '90.349685000000000000000',
//         clockout_lat: '23.832994299999999299189',
//         clockout_long: '90.349851099999995085454',
//         clocked_out_reason: 'clock_out_due_to_time',
//         selfie: null,
//         office: '10',
//         office_id: '22335044-849f-5c8e-98cc-69540845c8g7',
//         public_zone: 'Medina',
//         public_zone_id: '684feee8-g8d3-56e9-0b7c-4e9g27ee1e454',
//       },
//     ],
//   },
//   {
//     employee: {
//       id: 'a1d2e3f4-1111-2222-3333-444455556666',
//       first_name: 'Nusrat Jahan',
//       last_name: 'Akter',
//       email: 'nusrat@spacesoft.co',
//       color: null,
//       role: 'employee',
//       office: {
//         id: 'e0c16b9f-2db0-4043-a53d-5fb1592cfea2',
//         name: 'Apploye HQ',
//       },
//       phone: '+8801712345678',
//       avatar: null,
//       user_code: null,
//       geofence_time_clock: true,
//       should_track: true,
//       location_track: true,
//       clockin_selfie: true,
//       designation: 'UI/UX Designer',
//     },
//     attendances: [
//       {
//         id: '91bdc1a1-aaaa-bbbb-cccc-ddddeeeeffff',
//         clockin_timestamp: 1771650000,
//         clockout_timestamp: 1771686000,
//         clockin_lat: '23.832982000000000000000',
//         clockin_long: '90.349685000000000000000',
//         clockout_lat: '23.833324000000000000000',
//         clockout_long: '90.350199000000000000000',
//         clocked_out_reason: 'end_of_shift',
//         selfie: null,
//         office: '12',
//         office_id: '33446155-95ag-6d9f-a9dd-70651956d9h8',
//         public_zone: 'Riyadh',
//         public_zone_id: '795gff9-h9e4-67fa-1c8d-5f0h38ff2f565',
//       },
//     ],
//   },
//   {
//     employee: {
//       id: 'b2f3e4d5-2222-3333-4444-555566667777',
//       first_name: 'Omar',
//       last_name: 'Khan',
//       email: 'omar@spacesoft.co',
//       color: null,
//       role: 'employee',
//       office: {
//         id: 'e0c16b9f-2db0-4043-a53d-5fb1592cfea2',
//         name: 'Apploye HQ',
//       },
//       phone: '+8801999887766',
//       avatar: null,
//       user_code: null,
//       geofence_time_clock: false,
//       should_track: true,
//       location_track: true,
//       clockin_selfie: false,
//       designation: 'Field Engineer',
//     },
//     attendances: [
//       {
//         id: 'c1a2b3c4-1111-2222-3333-444455556666',
//         clockin_timestamp: 1771600000,
//         clockout_timestamp: 1771620000,
//         clockin_lat: '23.830000000000000000000',
//         clockin_long: '90.350000000000000000000',
//         clockout_lat: '23.830100000000000000000',
//         clockout_long: '90.350100000000000000000',
//         clocked_out_reason: 'emergency_leave',
//         selfie: null,
//         office: '15',
//         office_id: '44557266-06bh-7e0g-b0ee-81762067e0i9',
//         public_zone: 'Jeddah',
//         public_zone_id: '806hgg0-i0f5-78gb-2d9e-6g1i49gg3g676',
//       },
//     ],
//   },
//   {
//     employee: {
//       id: 'c3d4e5f6-3333-4444-5555-666677778888',
//       first_name: 'Laila',
//       last_name: 'Ahmed',
//       email: 'laila@spacesoft.co',
//       color: null,
//       role: 'employee',
//       office: {
//         id: 'e0c16b9f-2db0-4043-a53d-5fb1592cfea2',
//         name: 'Apploye HQ',
//       },
//       phone: '+8801777665544',
//       avatar: null,
//       user_code: null,
//       geofence_time_clock: false,
//       should_track: true,
//       location_track: true,
//       clockin_selfie: false,
//       designation: 'Supervisor',
//     },
//     attendances: [
//       {
//         id: 'd4e5f6a7-4444-5555-6666-777788889999',
//         clockin_timestamp: 1771700000,
//         clockout_timestamp: 1771720000,
//         clockin_lat: '23.835000000000000000000',
//         clockin_long: '90.352000000000000000000',
//         clockout_lat: '23.835100000000000000000',
//         clockout_long: '90.352100000000000000000',
//         clocked_out_reason: 'normal',
//         selfie: null,
//         office: '8',
//         office_id: '10235033-738f-4b7d-97bb-58e429b74af6',
//         public_zone: 'Arafat',
//         public_zone_id: '573eddc7-f7c2-45d8-9a6b-3d8f16ddc343',
//       },
//     ],
//   },
//   {
//     employee: {
//       id: 'd4e5f6a7-4444-5555-6666-777788889999',
//       first_name: 'Ahmed',
//       last_name: 'Ali',
//       email: 'ahmed@spacesoft.co',
//       color: null,
//       role: 'employee',
//       office: {
//         id: 'e0c16b9f-2db0-4043-a53d-5fb1592cfea2',
//         name: 'Apploye HQ',
//       },
//       phone: '+8801666554433',
//       avatar: null,
//       user_code: null,
//       geofence_time_clock: false,
//       should_track: true,
//       location_track: true,
//       clockin_selfie: false,
//       designation: 'Project Manager',
//     },
//     attendances: [
//       {
//         id: 'e5f6a7b8-5555-6666-7777-888899990000',
//         clockin_timestamp: 1771750000,
//         clockout_timestamp: 1771770000,
//         clockin_lat: '23.832500000000000000000',
//         clockin_long: '90.350500000000000000000',
//         clockout_lat: '23.832600000000000000000',
//         clockout_long: '90.350600000000000000000',
//         clocked_out_reason: 'normal',
//         selfie: null,
//         office: '20',
//         office_id: '55668377-17ci-8f1h-c1ff-92873178f1j0',
//         public_zone: 'Dammam',
//         public_zone_id: '917ijj1-j1g6-89hc-3e0f-7h2j50hh4h787',
//       },
//     ],
//   },
//   {
//     employee: {
//       id: 'e5f6a7b8-5555-6666-7777-888899990001',
//       first_name: 'Fatima',
//       last_name: 'Hassan',
//       email: 'fatima@spacesoft.co',
//       color: null,
//       role: 'employee',
//       office: {
//         id: 'e0c16b9f-2db0-4043-a53d-5fb1592cfea2',
//         name: 'Apploye HQ',
//       },
//       phone: '+8801988776655',
//       avatar: null,
//       user_code: null,
//       geofence_time_clock: true,
//       should_track: true,
//       location_track: true,
//       clockin_selfie: true,
//       designation: 'Accountant',
//     },
//     attendances: [
//       {
//         id: 'f6a7b8c9-6666-7777-8888-999900001111',
//         clockin_timestamp: 1771800000,
//         clockout_timestamp: null,
//         clockin_lat: '23.837000000000000000000',
//         clockin_long: '90.348000000000000000000',
//         clockout_lat: null,
//         clockout_long: null,
//         clocked_out_reason: null,
//         selfie: null,
//         office: '12',
//         office_id: '33446155-95ag-6d9f-a9dd-70651956d9h8',
//         public_zone: 'Riyadh',
//         public_zone_id: '795gff9-h9e4-67fa-1c8d-5f0h38ff2f565',
//       },
//     ],
//   },
//   {
//     employee: {
//       id: 'f6a7b8c9-6666-7777-8888-999900001112',
//       first_name: 'Hassan',
//       last_name: 'Ibrahim',
//       email: 'hassan@spacesoft.co',
//       color: null,
//       role: 'employee',
//       office: {
//         id: 'e0c16b9f-2db0-4043-a53d-5fb1592cfea2',
//         name: 'Apploye HQ',
//       },
//       phone: '+8801877665544',
//       avatar: null,
//       user_code: null,
//       geofence_time_clock: false,
//       should_track: true,
//       location_track: true,
//       clockin_selfie: false,
//       designation: 'HR Manager',
//     },
//     attendances: [
//       {
//         id: 'g7b8c9d0-7777-8888-9999-000011112222',
//         clockin_timestamp: 1771850000,
//         clockout_timestamp: 1771870000,
//         clockin_lat: '23.828000000000000000000',
//         clockin_long: '90.354000000000000000000',
//         clockout_lat: '23.828100000000000000000',
//         clockout_long: '90.354100000000000000000',
//         clocked_out_reason: 'end_of_shift',
//         selfie: null,
//         office: '10',
//         office_id: '22335044-849f-5c8e-98cc-69540845c8g7',
//         public_zone: 'Medina',
//         public_zone_id: '684feee8-g8d3-56e9-0b7c-4e9g27ee1e454',
//       },
//       {
//         id: 'g7b8c9d0-7777-8888-9999-000011112223',
//         clockin_timestamp: 1771900000,
//         clockout_timestamp: 1771920000,
//         clockin_lat: '23.828000000000000000000',
//         clockin_long: '90.354000000000000000000',
//         clockout_lat: '23.828100000000000000000',
//         clockout_long: '90.354100000000000000000',
//         clocked_out_reason: 'visited_another_camp',
//         selfie: null,
//         office: '15',
//         office_id: '44557266-06bh-7e0g-b0ee-81762067e0i9',
//         public_zone: 'Jeddah',
//         public_zone_id: '806hgg0-i0f5-78gb-2d9e-6g1i49gg3g676',
//       },
//     ],
//   },
//   {
//     employee: {
//       id: 'h8c9d0e1-8888-9999-0000-111122223333',
//       first_name: 'Maria',
//       last_name: 'Garcia',
//       email: 'maria@spacesoft.co',
//       color: null,
//       role: 'employee',
//       office: {
//         id: 'e0c16b9f-2db0-4043-a53d-5fb1592cfea2',
//         name: 'Apploye HQ',
//       },
//       phone: '+8801766554422',
//       avatar: null,
//       user_code: null,
//       geofence_time_clock: false,
//       should_track: true,
//       location_track: true,
//       clockin_selfie: false,
//       designation: 'Operations Lead',
//     },
//     attendances: [
//       {
//         id: 'h8c9d0e1-8888-9999-0000-111122223334',
//         clockin_timestamp: 1771600000,
//         clockout_timestamp: 1771615000,
//         clockin_lat: '23.834000000000000000000',
//         clockin_long: '90.349000000000000000000',
//         clockout_lat: '23.834100000000000000000',
//         clockout_long: '90.349100000000000000000',
//         clocked_out_reason: 'clock_out_due_to_time',
//         selfie: null,
//         office: '20',
//         office_id: '55668377-17ci-8f1h-c1ff-92873178f1j0',
//         public_zone: 'Dammam',
//         public_zone_id: '917ijj1-j1g6-89hc-3e0f-7h2j50hh4h787',
//       },
//     ],
//   },
//   {
//     employee: {
//       id: 'x5',
//       first_name: 'Shakil',
//       last_name: 'Ahmed',
//       email: 'shakil@spacesoft.co',
//       role: 'employee',
//       office: {
//         id: 'e0c16b9f-2db0-4043-a53d-5fb1592cfea2',
//         name: 'Apploye HQ',
//       },
//       phone: '+8801911111111',
//       designation: 'Technician',
//       should_track: true,
//       location_track: true,
//     },
//     attendances: [
//       {
//         id: 'x5-att-1',
//         clockin_timestamp: 1771683000,
//         clockout_timestamp: 1771688000,
//         office: '8',
//         office_id: '10235033-738f-4b7d-97bb-58e429b74af6', // Arafat group
//         public_zone: 'Arafat',
//         public_zone_id: '573eddc7-f7c2-45d8-9a6b-3d8f16ddc343',
//       },
//     ],
//   },
//   {
//     employee: {
//       id: 'x6',
//       first_name: 'Mehedi',
//       last_name: 'Hasan',
//       email: 'mehedi@spacesoft.co',
//       role: 'employee',
//       office: {
//         id: 'e0c16b9f-2db0-4043-a53d-5fb1592cfea2',
//         name: 'Apploye HQ',
//       },
//       phone: '+8801922222222',
//       designation: 'Support Staff',
//       should_track: true,
//       location_track: true,
//     },
//     attendances: [
//       {
//         id: 'x6-att-1',
//         clockin_timestamp: 1771686000,
//         clockout_timestamp: 1771691000,
//         office: '8',
//         office_id: '10235033-738f-4b7d-97bb-58e429b74af6', // SAME Arafat
//         public_zone: 'Arafat',
//         public_zone_id: '573eddc7-f7c2-45d8-9a6b-3d8f16ddc343',
//       },
//     ],
//   },
//   {
//     employee: {
//       id: 'x7',
//       first_name: 'Rafi',
//       last_name: 'Khan',
//       email: 'rafi@spacesoft.co',
//       role: 'employee',
//       office: {
//         id: 'e0c16b9f-2db0-4043-a53d-5fb1592cfea2',
//         name: 'Apploye HQ',
//       },
//       phone: '+8801933333333',
//       designation: 'Field Engineer',
//       should_track: true,
//       location_track: true,
//     },
//     attendances: [
//       {
//         id: 'x7-att-1',
//         clockin_timestamp: 1771690000,
//         clockout_timestamp: 1771695000,
//         office: '10',
//         office_id: '22335044-849f-5c8e-98cc-69540845c8g7', // Medina group
//         public_zone: 'Medina',
//         public_zone_id: '684feee8-g8d3-56e9-0b7c-4e9g27ee1e454',
//       },
//     ],
//   },
//   {
//     employee: {
//       id: 'x8',
//       first_name: 'Jahid',
//       last_name: 'Islam',
//       email: 'jahid@spacesoft.co',
//       role: 'employee',
//       office: {
//         id: 'e0c16b9f-2db0-4043-a53d-5fb1592cfea2',
//         name: 'Apploye HQ',
//       },
//       phone: '+8801944444444',
//       designation: 'Coordinator',
//       should_track: true,
//       location_track: true,
//     },
//     attendances: [
//       {
//         id: 'x8-att-1',
//         clockin_timestamp: 1771693000,
//         clockout_timestamp: 1771699000,
//         office: '10',
//         office_id: '22335044-849f-5c8e-98cc-69540845c8g7', // SAME Medina
//         public_zone: 'Medina',
//         public_zone_id: '684feee8-g8d3-56e9-0b7c-4e9g27ee1e454',
//       },
//     ],
//   },
//   {
//     employee: {
//       id: 'x9',
//       first_name: 'Nayeem',
//       last_name: 'Rahman',
//       email: 'nayeem@spacesoft.co',
//       role: 'employee',
//       office: {
//         id: 'e0c16b9f-2db0-4043-a53d-5fb1592cfea2',
//         name: 'Apploye HQ',
//       },
//       phone: '+8801955555555',
//       designation: 'Supervisor',
//       should_track: true,
//       location_track: true,
//     },
//     attendances: [
//       {
//         id: 'x9-att-1',
//         clockin_timestamp: 1771702000,
//         clockout_timestamp: 1771708000,
//         office: '20',
//         office_id: '55668377-17ci-8f1h-c1ff-92873178f1j0', // Dammam group
//         public_zone: 'Dammam',
//         public_zone_id: '917ijj1-j1g6-89hc-3e0f-7h2j50hh4h787',
//       },
//     ],
//   },
// ];

// Store props to map with current state
const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  clockInOutList: state.clockInOut.clockInOutList,
  // clockInOutList: dummyClockInOutList,
  isLoading: state.clockInOut.isLoading,

  officesShortList: state.office.officesShortList,
  publicZoneList: state.office.publicZoneList,
  locationsList: state.task.locationsList,
  orgMembersList: state.project.orgMembersList,

  // pagination
  clockInOutListCount: state.clockInOut.clockInOutListCount,
  clockInOutPageSize: state.clockInOut.clockInOutPageSize,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getClockInOutList: payload => dispatch(getClockInOutList(payload)),
  getOfficesShortList: payload => dispatch(getOfficesShortList(payload)),
  getPublicZoneList: params => dispatch(getPublicZoneList(params)),
  getTaskLocation: params => dispatch(getTaskLocation(params)),
  getOrganizationMembersList: params => dispatch(getOrganizationMembersList(params)),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(ClockInOut);